// FILE: components/notifications/useUnreadCount.ts
"use client";

import { useState, useEffect, useCallback } from "react";
import { getUnreadCount } from "@/actions/notifications";

/**
 * Hook đếm notification chưa đọc — polling mỗi 60s
 * Sau này chuyển sang Supabase Realtime thì thay logic bên trong, interface giữ nguyên.
 */
export function useUnreadCount(userId?: string) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    if (!userId) return;
    getUnreadCount().then(setCount);
  }, [userId]);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 60_000); // poll mỗi 60s
    return () => clearInterval(interval);
  }, [refresh]);

  // Listen event bus → refetch ngay khi có notification mới (VD: mua freeze)
  useEffect(() => {
    const onChange = () => refresh();
    window.addEventListener("jb:notifications-changed", onChange);
    return () => window.removeEventListener("jb:notifications-changed", onChange);
  }, [refresh]);

  return { count, setCount, refresh };
}
